(function (Drupal) {
  Drupal.behaviors.accordionBehavior = {
    attach: function (context, settings) {
      const accordionHeaders = context.querySelectorAll('.accordion-header');

      accordionHeaders.forEach(header => {
        // Ensure the event is added only once per element
        if (!header.hasAttribute('data-accordion-initialized')) {
          header.addEventListener('click', () => {
            const expanded = header.getAttribute('aria-expanded') === 'true';
            const content = document.getElementById(header.getAttribute('aria-controls'));

            if (expanded) {
              // Collapse the currently open accordion
              header.setAttribute('aria-expanded', 'false');
              content.classList.add('collapsed');
            } else {
              // Expand the clicked accordion
              header.setAttribute('aria-expanded', 'true');
              content.classList.remove('collapsed');
            }

            // Optionally, close other accordions if you only want one open at a time
            document.querySelectorAll('.accordion-header[aria-expanded="true"]').forEach(openHeader => {
              if (openHeader !== header) {
                openHeader.setAttribute('aria-expanded', 'false');
                const openContent = document.getElementById(openHeader.getAttribute('aria-controls'));
                openContent.classList.add('collapsed');
              }
            });
          });

          // Mark this header as initialized
          header.setAttribute('data-accordion-initialized', 'true');
        }
      });
    }
  };
})(Drupal);
